import { gql } from '@apollo/client';

export default gql`
  mutation OnboardUser($input: OnboardingInput!) {
    onboardUser(input: $input)
  }
`;
